<template>
  <div>
    <v-combobox
      ref="selector"
      v-validate="validation"
      :append-icon="dropdownIcon"
      :class="{'v-input--is-hidden': disableAdd}"
      :data-vv-name="name"
      :data-vv-scope="scope"
      :data-vv-as="label"
      :disabled="disabled"
      :error-messages="errorMessages"
      :hide-details="isSortable && !empty"
      :hide-no-data="!searchText"
      :items="items"
      :label="label"
      :search-input.sync="searchText"
      :value="internalValue"
      chips
      clearable
      close
      data-vv-value-path="value"
      deletable-chips
      hide-selected
      multiple
      small-chips
      @blur="onBlur"
      @change="onInput"
      @focus="onFocus"
    >
      <template v-slot:no-data>
        <v-list-tile>
          <span
            class="body-1"
            v-html="$t('message.form.fields.arraySelectorNoData')"
          />
          <v-chip small>
            {{ searchText }}
          </v-chip>
        </v-list-tile>
      </template>
      <template
        v-if="isSortable"
        v-slot:selection
      />
      <template
        v-else
        v-slot="{ item, selected }"
      >
        <v-chip
          :selected="selected"
          label
          small
        >
          <span class="pr-2">{{ item }}</span>
          <v-icon
            small
            :disabled="disabled"
            @click="onCloseItem(item)"
          >
            close
          </v-icon>
        </v-chip>
      </template>
    </v-combobox>
    <v-card
      v-show="!empty"
      v-if="isSortable"
      flat
      style="margin-top: 1px;"
      class="mb-2"
      color="primary lighten-4"
    >
      <v-card-text>
        <draggable
          v-model="internalValue"
          class="nx-draggable-container"
          @change="onChange"
        >
          <v-chip
            v-for="(s, index) in internalValue"
            :key="`${index}-${s}`"
            :close="!disableDelete"
            @input="onChipInput(s)"
          >
            <v-icon
              small
              left
            >
              drag_indicator
            </v-icon>
            {{ s }}
          </v-chip>
        </draggable>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import FormElement from '@/modules/form/mixins/form-element';
import draggable from 'vuedraggable';

export default {
  name: 'NxFormSortableStringArraySelector',
  components: {
    draggable,
  },
  mixins: [FormElement],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    sortable: Boolean,
    disableAdd: {
      type: Boolean,
      default: false,
    },
    disableDelete: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchText: '',
      internalValue: [],
    };
  },
  computed: {
    isSortable() {
      return !this.disabled && this.sortable;
    },
    dropdownIcon() {
      return (this.items.length > 0) ? 'arrow_drop_down' : null;
    },
  },
  watch: {
    value: {
      handler(value) {
        this.internalValue = [].concat(value);
      },
      immediate: true,
    },
  },
  methods: {
    onChipInput(item) {
      const index = this.internalValue.indexOf(item);
      this.internalValue.splice(index, 1);
      this.onInput(this.internalValue);
    },
    onInput(newValue) {
      this.$emit('input', newValue);
      this.$parentForm.updateField(this.name, newValue);
    },
    onBlur() {
      this.$emit('blur', true);
      this.flags.focused = false;
    },
    onFocus() {
      this.$emit('focus', true);
      this.flags.focused = true;
    },
    onChange(e) {
      if (this.disabled) return;
      const { newIndex, oldIndex } = e;
      this.internalValue.splice(newIndex, 0, this.internalValue.splice(oldIndex, 1)[0]);
      this.onInput(this.internalValue);
    },
  },
};
</script>

<style lang="stylus">
.nx-draggable-container {
  .v-chip .v-chip__content {
    cursor: move;
  }
}
.v-text-field.v-input--is-hidden {
  .v-input__control {
    .v-input__slot {
      cursor: default;

      &:before {
        content: none;
      }
    }
    .v-label {
      position: relative!important;
    }
    .v-select__selections,
    .v-input__append-inner {
      display: none;
    }
  }
}
</style>
